<template>
  <div>
    <md-card>
      <md-card-content class="md-layout">
        <p class="md-layout-item md-size-100 pb-4 p-0">
          {{ $t("extended_exportation.exported_report") }}
        </p>
        <div class="md-layout-item md-size-30 pl-0">
          <md-field>
            <label>{{ $t("student.program") }}</label>
            <md-select v-model="programSelected" name="program" id="program">
              <md-option
                v-for="(program, index) in programList"
                :key="program.name + index"
                :value="program.id"
              >
                {{ program.name }}
              </md-option>
            </md-select>
          </md-field>
        </div>
        <div class="md-layout-item md-size-30 pl-0">
          <checkbox-multi-select
            label="common.grade"
            :options="gradeList"
            v-model="gradeSelected"
            trackBy="name"
            :showSelectAll="true"
          ></checkbox-multi-select>
        </div>
        <div class="md-layout-item md-size-30 pl-0">
          <md-field>
            <label>{{ $t("class.term") }}</label>
            <md-select v-model="termSelected">
              <md-option
                v-for="option in termList"
                :value="option.id"
                :key="option.id + option.name"
                >{{ option.name }}
              </md-option>
            </md-select>
          </md-field>
        </div>
        <div class="md-layout-item md-size-30 pl-0">
          <date-picker-custom
            :label="$t('common.start_date')"
            v-model="startDate"
          ></date-picker-custom>
        </div>
        <div class="md-layout-item md-size-30 pl-0">
          <date-picker-custom
            :label="$t('common.end_date')"
            v-model="endDate"
          ></date-picker-custom>
        </div>
      </md-card-content>
    </md-card>
    <div class="flex justify-center pt-2">
      <md-button class="md-warning md-round" @click="exportPDF()"
        >{{ $t("common.export") }}
      </md-button>
    </div>
  </div>
</template>

<script>
import CheckboxMultiSelect from "@/components/Base/CheckboxMultiSelect.vue";
import { Message } from "@/helpers/utils";
import { service_paths } from "@/constants/Services";

export default {
  components: { CheckboxMultiSelect },
  data() {
    return {
      programSelected: null,
      programList: [],
      termSelected: "",
      termList: [],
      gradeList: [],
      gradeSelected: [],
      startDate: "",
      endDate: ""
    };
  },
  created() {
    this.getProgramList();
    this.fetchGradeOpts();
    this.fetchTermOpts();
  },
  methods: {
    getProgramList() {
      return this.$axios
        .get(
          `${service_paths.programs}`,
          undefined,
          undefined,
          undefined,
          undefined,
          undefined,
          false
        )
        .then(({ data }) => {
          if (data) {
            this.programList = data.data;
            this.programSelected = this.programList[0]?.id;
          }
        });
    },
    fetchTermOpts() {
      this.$axios
        .get(service_paths.terms, { order_by: "created_at DESC", limit: 100 })
        .then(response => {
          this.termList = response.data.data.map(term => ({
            id: term.id,
            name: term.name
          }));
          this.termSelected = this.termList[0].id;
        });
    },
    fetchGradeOpts() {
      this.$axios
        .get(`${service_paths.grades}`, { limit: 20 })
        .then(response => {
          this.gradeList = response.data.data.map(grade => {
            this.gradeSelected.push(grade.name);
            return {
              id: grade.id,
              name: grade.name
            };
          });
        });
    },
    formatParams(params) {
      if (!params.entered) {
        delete params.entered;
      }
      if (!params.graduation_or_withdraw) {
        delete params.graduation_or_withdraw;
      }
    },
    exportPDF() {
      let params = {
        program_id: this.programSelected,
        term_id: this.termSelected,
        grade_names: this.gradeSelected,
        entered: this.startDate,
        graduation_or_withdraw: this.endDate
      };
      this.formatParams(params);
      if (
        params.entered &&
        params.graduation_or_withdraw &&
        params.entered >= params.graduation_or_withdraw
      ) {
        Message.error(
          this.$t("class.the_end_date_must_be_a_date_after_start_date")
        );
      } else {
        this.$axios
          .get(
            `${service_paths.export}/master-register/pdf`,
            params,
            undefined,
            undefined,
            "blob",
            null,
            false,
            false
          )
          .then(response => {
            if (response.status === 200) {
              const url = window.URL.createObjectURL(new Blob([response.data]));
              const link = document.createElement("a");
              link.href = url;
              link.setAttribute("download", "master_register.pdf");
              document.body.appendChild(link);
              link.click();
              link.remove();
            } else {
              Message.error(this.$t("common.an_error_occurred"));
            }
          });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep .checkbox-multi-selections label {
  display: block;
  margin: -3px 0;
  color: #aaa;
  font-weight: 400;
}
</style>
